import apiClient from './axiosClient';

export const createService = (data) => apiClient.post(`/services/`, data);
export const getService = (id) => apiClient.get(`/services/${id}/`);
export const completeService = (id, data) => apiClient.post(`/services/${id}/complete/`, data);
export const updateService = (id, data) => apiClient.put(`/services/${id}/`, data);
export const patchService = (id, data) => apiClient.patch(`/services/${id}/`, data);
export const deleteService = (id) => apiClient.delete(`/services/${id}/`);

export const createServiceItem = (data) => apiClient.post(`/service-items/`, data);
export const updateServiceItem = (id, data) => apiClient.post(`/service-items/${id}/`, data);
export const deleteServiceItem = (id) => apiClient.post(`/service-items/${id}/`);

export const getServicesByDate = (date) => apiClient.get(`/services/?service_date=${date}`);
export const getStatusChoices = () => apiClient.get(`/services/status-choices/`);
export const getServiceCapacity = (startDate, endDate, branchId) => apiClient.get('/services/capacity/', {
  params: { start_date: startDate, end_date: endDate, branch_id: branchId },
});
